import { useDispatch, useSelector } from "react-redux";

import {
  ColorSecondary,
  ColorTestPilot,
  IgButton,
} from "@intelligems/ig-theme";
import { Badge } from "@mui/material";

import {
  dispatchExperienceAnalysis,
  experienceAnalysis,
} from "../../../../store/slices/ai";
import { mpClickAiExperienceAnalysisButton } from "../../../../utils/mixpanel";

export const AiAnalysisButton = () => {
  const analysis = useSelector(experienceAnalysis);
  const dispatch = useDispatch();

  return (
    <Badge
      badgeContent={"New"}
      sx={{
        "& .MuiBadge-badge": {
          color: "white",
          backgroundColor: "#FD6B02",
          border: "solid #F5F5F5 1px",
        },
      }}
    >
      <IgButton
        sx={{
          "&:hover": {
            color: "white",
            backgroundColor: ColorTestPilot.orange,
            borderColor: ColorTestPilot.orange,
          },
          "&:focus": {
            color: ColorSecondary.main,
            backgroundColor: "white",
            borderColor: ColorSecondary.light,
          },
        }}
        igVariant={"white"}
        onClick={() => {
          if (analysis.isHidden) {
            mpClickAiExperienceAnalysisButton();
          }
          dispatch(
            dispatchExperienceAnalysis({
              type: "setIsHidden",
              value: !analysis.isHidden,
            })
          );
        }}
      >
        AI Insights
      </IgButton>
    </Badge>
  );
};
